export default {
  title: 'Rueda',
  actions: {
    create: 'crear una rueda',
    confirmDelete: '¿Estás seguro de que quieres eliminar esta rueda?',
    delete: 'Eliminar',
    next: 'Siguiente',
    cancel: 'Cancelar',
    save: 'Guardar'
  },
  empty: {
    title: 'Sin ruedas',
    message: 'Para crear una rueda, simplemente haz clic en el siguiente enlace:'
  },
  create: {
    title: 'Crear una rueda',
    fields: {
    name: 'Nombre',
    date: {
      name: 'Fecha',
      start: 'Inicio',
      end: 'Fin'
    },
    where: 'Dónde'
    }
  },
  list: {
    name: 'nombre',
    code: 'código',
    status: 'estado',
    where: 'dónde',
    date: 'fecha',
    stats: 'estadística'
  }
}


// WEBPACK FOOTER //
// ./src/translations/es/wheel.js